import { withCompController } from '@wix/editor-elements-integrations';
import { getSocialUrl } from '@wix/editor-elements-common-utils';
import type {
  WTwitterTweetMapperProps,
  WTwitterTweetControllerProps,
  IWTwitterTweetProps,
  WTwitterTweetStateRefs,
} from '../WTwitterTweet.types';
import { mapConsentPolicyStateRefValues } from '../../ConsentPolicyWrapper/viewer/utils';

const compController = withCompController<
  WTwitterTweetMapperProps,
  WTwitterTweetControllerProps,
  IWTwitterTweetProps,
  WTwitterTweetStateRefs
>(({ stateValues, mapperProps }) => {
  const {
    urlFormat,
    isMasterPage,
    externalBaseUrl,
    isHttpsEnabled,
    ...restProps
  } = mapperProps;

  const { pageId, relativeUrl, currentUrlWithQueryParams, currentUrl } =
    stateValues;

  const socialUrl = getSocialUrl({
    urlFormat,
    isMasterPage,
    pageId,
    relativeUrl,
    externalBaseUrl,
    isHttpsEnabled,
    currentUrl: isMasterPage ? externalBaseUrl : currentUrlWithQueryParams,
  });

  return {
    ...restProps,
    socialUrl,
    currentUrl,
    ...mapConsentPolicyStateRefValues(stateValues),
  };
});

export default compController;
